import { ToastAction, ToastDurations, ToastSeverity } from './useToast/Toast';
import { createContext } from 'react';

export type ShowToastParams = {
  message: string;
  severity: ToastSeverity;
  /** Undefined means the toast never closes itself (`useTimeout` disarms). */
  autoHideDuration?: number;
  action?: ToastAction;
};

export type ShowToast = (params: ShowToastParams) => void;

export type ToastContextValue = {
  showToast: ShowToast;
  durations: ToastDurations;
};

/**
 * Supplied by both `ToastProvider` (apps) and `SiteToastProvider` (sites), so
 * `useToast` knows about neither.
 */
export const ToastContext = createContext<ToastContextValue | undefined>(
  undefined,
);
